import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  setAllEvents,
  setSigleEvent,
  removeEvent,
  setSingleSection,
  addSingleEventSection,
  removeEventSeciton,
  setEventSecitons,
  setSectionTickets,
  removeTicket,
  setEvenTicketTokenList,
  setSingleWGEvent,
  settActiveWGEvent,
} from "redux/actions/Events";

import axios from "../auth/jwt/config";

const EventsRequests = {
  getAllEvents: () => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get("/event/getall/admin")
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllEvents(data.events));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getEventById: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/event/getsingle/${id}`)
          .then(({ data }) => {
            console.log(data);
            dispatch(fetchSuccess());
            dispatch(setSigleEvent(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getEventSectionsById: (eventId) => {
    return (dispatch) => {
      try {
        axios
          .get(`/eventSection/getSpecificEventSections/${eventId}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setEventSecitons(data.eventSections));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getEventSectionById: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/eventSection/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleSection(data.eventSection));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getWGEventById: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/wordgame/event/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleWGEvent(data.wordGameEvent));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  updateWGEvent: (id, updatedEvent) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/wordgame/event/update/${id}`, updatedEvent)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  createSingleEvent: (event) => {
    return (dispatch) => {
      try {
        axios
          .post(`/event/create`, event)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getAllAciveWGEvents: () => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get("/wordgame/event/getall/user?page=1&limit=500&searchString&archived=false")
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(settActiveWGEvent(data.docs));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  createSingleWordGameEvent: (event) => {
    return (dispatch) => {
      try {
        axios
          .post(`wordgame/event/create`, event)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  addEventSection: (sectionData) => {
    return (dispatch) => {
      try {
        axios
          .post(`/eventSection/create`, sectionData)
          .then(({ data }) => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
            dispatch(addSingleEventSection(data.eventSection));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  updateEvent: (id, updatedEvent) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/event/update/${id}`, updatedEvent)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  updateEventSection: (id, updatedEventSection) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/eventSection/update/${id}`, updatedEventSection)
          .then(({ data }) => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  removeSingleEvent: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/event/delete/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeEvent(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  removeEventSectionById: (secitonId) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/eventSection/delete/${secitonId}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeEventSeciton(secitonId));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getSectionTicketsById: (sectionId) => {
    return (dispatch) => {
      try {
        axios
          .get(`/eventTicket/sectionTickets/${sectionId}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSectionTickets(data.sectionTickets));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  removeSectionTicket: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/eventTicket/delete/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeTicket(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getEventTicketTokenList: () => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get("/eventTicketToken/getall")
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setEvenTicketTokenList(data.eventTicketTokens));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  createSingleEventToken: (ticketToken) => {
    return (dispatch) => {
      try {
        axios
          .post(`/eventTicketToken/create`, ticketToken)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
            EventsRequests.getEventTicketTokenList()(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  removeEventTokenTicket: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/eventTicketToken/delete/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            EventsRequests.getEventTicketTokenList()(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  updateEventTicketToken: (id, updatedEventToken) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/eventTicketToken/update/${id}`, updatedEventToken)
          .then(({ data }) => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
            setTimeout(() => {
              EventsRequests.getEventTicketTokenList()(dispatch);
            }, 1000);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default EventsRequests;
